import toast from "react-hot-toast";
import * as api from "../Api";
export const createSubmission = (postData) => async (dispatch) => {
  let creatingId;
  try {
    creatingId = toast.loading("Creating submission...");
    const { data } = await api.createSubmission(postData);
    dispatch({ type: "CREATE_SUBMISSION", payload: data });
    toast.remove(creatingId);
    toast.success("Submission created successfully");
  } catch (error) {
    toast.remove(creatingId);
    toast.error(error.message);
  }
};

export const updateSubmission =
  (branch, date, postData) => async (dispatch) => {
    let updatingId;
    try {
      updatingId = toast.loading("Updating submission...");
      const { data } = await api.updateSubmission(branch, date, postData);
      dispatch({ type: "UPDATE_RECONCILIATION_SUBMISSION", payload: data });
      toast.remove(updatingId);
      toast.success("Submission updated successfully");
      return data;
    } catch (error) {
      toast.remove(updatingId);
      toast.error(error.message);
      throw error;
    }
  };
